var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18737 7.94984L7.38808 5.77413L0.820941 5.74413C0.720513 5.74375 0.621143 5.72359 0.528512 5.68479C0.435882 5.64599 0.351806 5.58931 0.281091 5.518C0.210377 5.44669 0.154409 5.36214 0.116389 5.26919C0.0783701 5.17623 0.059042 5.0767 0.0595121 4.97627C0.0599804 4.87581 0.0802307 4.77642 0.119109 4.68379C0.157987 4.59115 0.21473 4.50708 0.286098 4.43638C0.357468 4.36567 0.442064 4.30972 0.535058 4.2717C0.628052 4.23369 0.727623 4.21437 0.828084 4.21484L7.3938 4.24484L5.22237 2.0477C5.15157 1.97637 5.09552 1.8918 5.05742 1.79881C5.01932 1.70582 4.99991 1.60623 5.00031 1.50574C5.00071 1.40524 5.0209 1.30581 5.05974 1.21313C5.09858 1.12044 5.1553 1.03631 5.22666 0.965555C5.37089 0.822843 5.56586 0.743211 5.76876 0.744149C5.97166 0.745086 6.16589 0.826516 6.3088 0.970555L9.88023 4.57698C9.99701 4.69567 10.0619 4.85589 10.0605 5.02239C10.0592 5.18889 9.99176 5.34805 9.87309 5.46484L6.2638 9.03627C6.11969 9.17894 5.92483 9.25855 5.72205 9.25762C5.51927 9.25668 5.32515 9.17526 5.18237 9.03127C5.0397 8.88716 4.96009 8.6923 4.96103 8.48952C4.96196 8.28674 5.04338 8.09263 5.18737 7.94984Z",
    fill: "#4CB596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3);
export default __webpack_public_path__ + "static/media/arrow-3.3cf0ac465d2693ee972e7feb2ed91660.svg";
export { ForwardRef as ReactComponent };